export const BUSINESS = {
  name: "The Lash Bar",
  tagline: "Lashes | Hair | Tanning",
  phone: "(801) 473-2615",
  phoneTel: "tel:8014732615",
  address: "3397 N 1200 E Suite 110",
  city: "Lehi",
  state: "UT",
  zip: "84043",
  fullAddress: "3397 N 1200 E Suite 110, Lehi, UT 84043",
  directionsUrl: "https://goo.gl/maps/fMQvgKKY5mRxjqPA8",
  bookingUrl:
    "https://dashboard.boulevard.io/booking/businesses/1dc117c9-31f1-49a3-9094-6719fd2f14a0/widget#/cart/menu",
  facebookUrl: "https://www.facebook.com/LashBarUtah/",
  blogUrl: "https://hellodarlinglife.com/",
  shopUrl: "https://lash-bar-utah-boutique.myshopify.com/",
  reviewUrl: "https://g.page/r/CadhnAWZRAlvEB0/review",
  logoUrl:
    "https://i0.wp.com/www.lashbarutah.com/wp-content/uploads/2020/09/lashbar-logo-x2.png?resize=300%2C104&ssl=1",
  googleRating: 4.9,
  reviewCount: 901,
  mapEmbed:
    "https://www.google.com/maps/embed/v1/place?key=AIzaSyAZ2A2Jl5uChOVRTM9u_PJpg_exXebati4&language=en&q=3397+N+1200+E+Suite+110,+Lehi,+UT+84043&maptype=roadmap&zoom=16",
};

export const HOURS = [
  { day: "Monday", hours: "9AM – 7PM" },
  { day: "Tuesday", hours: "9AM – 8PM" },
  { day: "Wednesday", hours: "9AM – 8PM" },
  { day: "Thursday", hours: "9AM – 8PM" },
  { day: "Friday", hours: "9AM – 7PM" },
  { day: "Saturday", hours: "9AM – 4PM" },
  { day: "Sunday", hours: "10AM – 4PM" },
];

export const NAV_LINKS = [
  { label: "Services", href: "/services" },
  { label: "About", href: "/about" },
  { label: "Location", href: "/location" },
];

export const SERVICES = [
  {
    id: "lashes",
    title: "Lashes",
    subtitle: "Premier Lash Extensions & Lifts",
    description:
      "Voted Best Lashes in Utah. Our elite team of professional lash artists represents the finest talent in the state. Experience the excellence that makes The Lash Bar Utah's premier lash destination.",
    detailServices: [
      "Classic Lash Extensions",
      "Volume Lash Extensions",
      "Hybrid Lash Extensions",
      "Lash Lift & Tint",
      "Lash Removal",
      "Fill Appointments",
    ],
    icon: "ri-eye-line",
    image:
      "https://i0.wp.com/www.lashbarutah.com/wp-content/uploads/2023/02/lashes.png?resize=250%2C250&ssl=1",
    href: "/services",
  },
  {
    id: "hair",
    title: "Hair",
    subtitle: "Expert Styling & Color",
    description:
      "From stunning blowouts and wedding updos to precision cuts and vibrant colors, we do it all. Our versatile team includes stylists who also specialize in men's and children's cuts.",
    detailServices: [
      "Precision Haircuts",
      "Color & Highlights",
      "Blowouts",
      "Wedding & Updo Styling",
      "Men's Cuts",
      "Children's Cuts",
    ],
    icon: "ri-scissors-cut-line",
    image:
      "https://i0.wp.com/www.lashbarutah.com/wp-content/uploads/2023/02/hair.png?resize=250%2C250&ssl=1",
    href: "/services",
  },
  {
    id: "tanning",
    title: "Tanning",
    subtitle: "Premium Glow Services",
    description:
      "Achieve the perfect summer glow with our high-end tanning beds. Enhance your wellness routine with our infrared pod, or experience a flawless finish with our professional airbrush tanning.",
    detailServices: [
      "UV Tanning Beds",
      "Airbrush Tanning",
      "Infrared Pod",
      "Spray Tan",
      "Tanning Packages",
      "Glow Consultations",
    ],
    icon: "ri-sun-line",
    image:
      "https://i0.wp.com/www.lashbarutah.com/wp-content/uploads/2023/02/tanning.png?resize=250%2C250&ssl=1",
    href: "/services",
  },
];

export const TEAM = [
  {
    name: "Melissa Watts",
    role: "Founder",
    image:
      "https://lashbarutah.com/wp-content/uploads/2021/04/Headshots2021-3.jpg",
  },
  {
    name: "Shantell Douros",
    role: "Hair Stylist & Manager",
    image:
      "https://www.lashbarutah.com/wp-content/uploads/2024/12/shantell-douros.webp",
  },
  {
    name: "Haeli Jae Shurtleff",
    role: "VIP Lash Artist",
    image:
      "https://www.lashbarutah.com/wp-content/uploads/2024/12/haeli-jae-shurtleff.webp",
  },
  {
    name: "Halley Arntz",
    role: "VIP Lash Artist",
    image:
      "https://lashbarutah.com/wp-content/uploads/2021/04/Headshots2021-1.jpg",
  },
  {
    name: "Monica Mecham",
    role: "VIP Lash Artist",
    image:
      "https://www.lashbarutah.com/wp-content/uploads/2024/12/monica-mecham.webp",
  },
  {
    name: "Amber Breivik",
    role: "Hair Stylist",
    image:
      "https://www.lashbarutah.com/wp-content/uploads/2024/12/amber-breivik-scaled.webp",
  },
  {
    name: "Jodi Packer",
    role: "Lash and Hair Artist",
    image:
      "https://www.lashbarutah.com/wp-content/uploads/2024/12/jodi-packer.webp",
  },
  {
    name: "Stefany Mosqueda",
    role: "Lash Artist",
    image:
      "https://www.lashbarutah.com/wp-content/uploads/2024/12/stefany-mosqueda.webp",
  },
  {
    name: "Anna Lewis",
    role: "Lash Artist",
    image:
      "https://www.lashbarutah.com/wp-content/uploads/2024/12/anna-lewis-2.webp",
  },
  {
    name: "Amanda Durein",
    role: "Diamond Lash Artist",
    image:
      "https://www.lashbarutah.com/wp-content/uploads/2024/12/amanda-durein.webp",
  },
  {
    name: "Claire Rykert",
    role: "Guest Services",
    image:
      "https://www.lashbarutah.com/wp-content/uploads/2024/12/claire-rykert.webp",
  },
  {
    name: "Olea McPhearson",
    role: "Guest Services",
    image:
      "https://www.lashbarutah.com/wp-content/uploads/2024/12/olea-mcphearson.webp",
  },
];

export const REVIEWS = [
  {
    name: "Kristin Gray",
    rating: 5,
    text: "I had my first lash lift with Aubrey and she did wonders with my short little lashes. Her instructions for upkeep were clear. The lift lasted longer than the estimated time. I would highly recommend The Lash Bar.",
    date: "Last week",
  },
  {
    name: "Jaime Shippen",
    rating: 5,
    text: "I had an airbrush tan with Haeli Jae and she was so careful about explaining the process, making sure everything went perfectly. She gives you a nice even glow that looks natural. Super happy and definitely will be returning!",
    date: "A week ago",
  },
  {
    name: "Alison Woodward",
    rating: 5,
    text: "I had my first lift and tint here and it was a great experience! Aubrie was awesome! She made me feel super comfortable and I love how my lashes turned out. I'll definitely be back.",
    date: "A week ago",
  },
];

export const SERVICE_AREAS = [
  "Lehi, UT",
  "American Fork, UT",
  "Pleasant Grove, UT",
  "Orem, UT",
  "Provo, UT",
  "Lindon, UT",
  "Cedar Hills, UT",
  "Highland, UT",
  "Alpine, UT",
  "Eagle Mountain, UT",
  "Saratoga Springs, UT",
  "Draper, UT",
  "South Jordan, UT",
  "Riverton, UT",
  "Bluffdale, UT",
  "Vineyard, UT",
];

export const BRANDS = [
  {
    name: "RVCA",
    image:
      "https://i0.wp.com/www.lashbarutah.com/wp-content/uploads/2022/09/RVCA_LOGO.png?resize=300%2C63&ssl=1",
  },
  {
    name: "Mangiacotti",
    image:
      "https://i0.wp.com/www.lashbarutah.com/wp-content/uploads/2022/09/Mangiacotti-logo-art.jpg?resize=300%2C177&ssl=1",
  },
  {
    name: "Kérastase",
    image:
      "https://i0.wp.com/www.lashbarutah.com/wp-content/uploads/2022/09/Kerastase_New_logo.jpg?resize=300%2C85&ssl=1",
  },
];

export const AWARD_IMAGE =
  "https://i0.wp.com/www.lashbarutah.com/wp-content/uploads/2023/03/best-lashes-award.png?resize=330%2C273&ssl=1";

export const GIVING_BACK_IMAGE =
  "https://i0.wp.com/lashbarutah.com/wp-content/uploads/2021/02/IMG_0022-768x1024.jpg?resize=768%2C1024&ssl=1";
